import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";

export const useGetSeasonEntitiesStatisticReportUrl = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();

  return useQuery({
    queryKey: ["seasonEntitiesStatisticReport", sport, organizationId, seasonId],
    queryFn: async () => {
      return await fetchData({
        url: `${sport}/o/${organizationId}/reports/entities/statistic/in/season/${seasonId}`,
      });
    },
    enabled: false,
  });
};
